import CreateButton from '@fd/frontend/components/ProxyPoolCreatePage/CreateButton';
import CreatePoolFooter from '@fd/frontend/components/ProxyPoolCreatePage/CreatePoolFooter';
import CreateProxiesCard from '@fd/frontend/components/ProxyPoolCreatePage/CreateProxiesCard';
import LocationCard from '@fd/frontend/components/ProxyPoolCreatePage/LocationCard';
import NameCard from '@fd/frontend/components/ProxyPoolCreatePage/NameCard';
import ProtocolCard from '@fd/frontend/components/ProxyPoolCreatePage/ProtocolCard';
import ProxyTypeSelector from '@fd/frontend/components/ProxyPoolCreatePage/ProxyTypeSelector';
import RotationCard from '@fd/frontend/components/ProxyPoolCreatePage/RotationCard';
import { DesktopView, MobileView } from '@fd/frontend/components/responsive';
import Card from '@fd/frontend/components/ui/Card';
import Flex from '@fd/frontend/components/ui/Flex';
import Page from '@fd/frontend/components/ui/Page';

export default function ProxyPoolCreatePage() {
  return (
    <Page.Container>
      <Page.Heading>
        <Page.Title>Create proxy pool</Page.Title>
        <Page.Description>
          A proxy pool is a set of IP addresses that change automatically.
        </Page.Description>
      </Page.Heading>
      <Page.Body>
        <Card>
          <Flex.Col gap="5">
            <ProxyTypeSelector />
            <NameCard />
            <LocationCard />
            <RotationCard />
            <ProtocolCard />
            <CreateProxiesCard />
            <DesktopView>
              <Flex.Row className="justify-end">
                <CreateButton />
              </Flex.Row>
            </DesktopView>
            <MobileView>
              <CreatePoolFooter />
            </MobileView>
          </Flex.Col>
        </Card>
      </Page.Body>
    </Page.Container>
  );
}
